import { type AppTheme } from '@knack/asterisk-react';

/**
 * Check if the structure of the imported theme is valid by comparing it with the default theme.
 */
export function isThemeStructureValid(importedTheme: AppTheme, defaultAppTheme: AppTheme) {
  if (
    typeof importedTheme !== 'object' ||
    importedTheme === null ||
    typeof defaultAppTheme !== 'object' ||
    defaultAppTheme === null
  ) {
    return false;
  }

  const keys1 = Object.keys(importedTheme);
  const keys2 = Object.keys(defaultAppTheme);

  if (keys1.length !== keys2.length) {
    return false;
  }

  return keys1.every((key) => {
    if (!keys2.includes(key)) {
      return false;
    }
    const val1 = importedTheme[key];
    const val2 = defaultAppTheme[key];
    const areBothObjects = typeof val1 === 'object' && typeof val2 === 'object';

    if (areBothObjects) {
      return isThemeStructureValid(val1, val2);
    }
    return true;
  });
}
